import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
// import { Link } from 'react-router-dom';

import './artwork.scss';

let classNames = require('classnames');

@inject('appStore', 'routerStore')
@observer
export class ArtworkThumb extends Component {

    onClick(e, index, link) {
        const { appStore, routerStore } = this.props;
        e.preventDefault();

        let elements = document.getElementsByClassName('artwork-thumb--' + index),
            zoomState = {};

        routerStore.history.push(link);

        if (elements.length) {
            let position = elements[0].getBoundingClientRect();
            zoomState = {
                left: position.left + 'px',
                top: position.top + 'px',
                scaleX: position.width / window.outerWidth,
                scaleY: position.height / window.innerHeight,
                open: false
            };
            appStore.zoomState = zoomState;
        }

        setTimeout(() => {
            zoomState = {
                left: '0px',
                top: '0px',
                scaleX: 1,
                scaleY: 1,
                open: true
            };
            appStore.zoomState = zoomState;

            appStore.carouselOpen = true;
        }, 100);

        return false;
    }

    render() {
        const { index, artwork } = this.props,
            indexClass = 'artwork-thumb--' + index,
            classes = classNames({
                'artwork-thumb': true,
                [indexClass]: true
            }),
            delay = 75;

        let style = {
            width: artwork.WidthPercent + '%',
            height: artwork.HeightPercent + '%',
            top: artwork.TopPercent + '%',
            left: artwork.LeftPercent + '%',
            transitionDelay: `${index * delay}ms`
        };

        if (artwork.WidthPercent > 0) {
            return <button key={artwork.ID} className={classes} style={style}
                onClick={(e) => this.onClick(e, index, artwork.Link)}>
                <h5 className='artwork-thumb-title'>{artwork.Pos + 1}</h5>
                <img className='artwork-thumb-image' src={artwork.FramedImageURL} />
            </button>;
        } else {
            return <div />;
        }
    }

}



// WEBPACK FOOTER //
// ./src/_artwork/artwork.thumb.js